import { Button, EmptyState } from '@recipes/ui';
import { AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse, useNavigate, useRouteError } from 'react-router';

export function RouteErrorBoundary() {
  const error = useRouteError();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : t('app.unexpectedError');
  return (
    <div className="mx-auto max-w-lg p-6">
      <EmptyState
        icon={<AlertTriangle />}
        title={t('app.unexpectedError')}
        description={message}
        action={
          <Button onClick={() => navigate(0)} variant="outline">
            {t('app.retry')}
          </Button>
        }
      />
    </div>
  );
}
